import React, { useEffect } from "react";
import { SubSections } from "../../data/navItem";
import VentasDashboard from "./VentasDashboard";
import VentasCatalogo from "./VentasCatalogo";
import PedidosEspecialesCatalogo from "./PedidosEspecialesCatalogo";
import MetasDashboard from "../Metas/MetasDashboard";

export default function Reports({ subSectionId }) {
  const fetchData = async () => {};

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {subSectionId === SubSections.Dashboard && <VentasDashboard />}
      {subSectionId === SubSections.Ventas && <VentasCatalogo />}
      {/*subSectionId === SubSections.Devoluciones && <VentasCatalogo />*/}
      {subSectionId === SubSections.PedidosEspeciales && (
        <PedidosEspecialesCatalogo />
      )}
      {subSectionId === SubSections.Metas && <MetasDashboard />}
    </>
  );
}
